
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from './components/Hero';
import ESGCarbon from './components/ESGCarbon';
import Metals from './components/Metals';
import AISoftware from './components/AISoftware';
import WhyUs from './components/WhyUs';
import About from './components/About';
import Contact from './components/Contact';
import SharedHeader from '../../components/feature/SharedHeader';
import Footer from './components/Footer';

export default function HomePage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          const offset = 80;
          const top = element.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-white">
      <SharedHeader />
      <Hero />
      <ESGCarbon />
      <Metals />
      <AISoftware />
      <WhyUs />
      <About />
      <Contact />
      <Footer />
    </div>
  );
}
